export default __webpack_public_path__ + "19667063f401d4f3cc829a10f0680cae.svg";